import { Badge, IconButton, Menu, Box, Stack, useTheme, Typography, Divider } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import AppCustomIcon from '../icon/AppIcon';
import { useAppNotifications } from './providers/AppNotificationProvider';
import IAppNotification from './interfaces/IAppNotification';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import appNotificationLang from './langs/appNotificationLang';

const AppNotification = () => {
	const { notifications } = useAppNotifications();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const [notificationTypes, setNotificationTypes] = useState<string[] | null>(null);
	useEffect(() => {
		if (notifications) {
			setNotificationTypes(_.uniq(notifications.map((x) => x.typeTag)));
		}
	}, [notifications]);

	return (
		<>
			<IconButton size="large" color="primary" onClick={handleClick}>
				<Badge
					badgeContent={notifications?.length}
					variant="dot"
					overlap="circular"
					color="secondary"
					invisible={notifications?.length === 0}
				>
					<AppCustomIcon tag="notification" color="primary" />
				</Badge>
			</IconButton>
			{notifications && notificationTypes && notificationTypes.length > 0 ? (
				<Menu
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					PaperProps={{
						style: {
							maxHeight: '320px',
							width: '320px',
							padding: '10px 10px',
						},
					}}
				>
					{notificationTypes &&
						notificationTypes.map((notificationType, index) => {
							return (
								<Box key={index}>
									<GroupNotificationType
										notificationType={notificationType}
										notifications={notifications.filter((x) => x.typeTag === notificationType)}
										handleClose={handleClose}
									/>
									{index + 1 < notificationTypes.length ? (
										<Divider sx={{ margin: '20px 0px' }} />
									) : (
										''
									)}
								</Box>
							);
						})}
				</Menu>
			) : (
				''
			)}
		</>
	);
};

type GroupNotificationTypeProps = {
	notificationType: string;
	notifications: IAppNotification[];
	handleClose: () => void;
};
const GroupNotificationType = (props: GroupNotificationTypeProps) => {
	const { notificationType, notifications, handleClose } = props;
	const theme = useTheme();
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				width: '100%',
				color: theme.palette.primary.main,
			}}
		>
			<Stack
				direction="row"
				spacing={1}
				alignContent="center"
				justifyContent="flex-start"
				sx={{ padding: '0px 5px' }}
			>
				<Box>
					{notificationType === 'document' ? (
						<AppCustomIcon tag="folders" color="secondary" />
					) : notificationType === 'news' ? (
						<AppCustomIcon tag="news" color="secondary" />
					) : (
						''
					)}
				</Box>
				<Box sx={{ fontSize: '1rem', fontWeight: 600 }}>
					{notificationType === 'document'
						? t(appNotificationLang.x_documents.tag, { count: notifications.length })
						: notificationType === 'news'
						? t(appNotificationLang.x_news.tag, { count: notifications.length })
						: ''}
				</Box>
			</Stack>
			<Box sx={{ marginTop: '10px' }}>
				{notifications &&
					notifications.map((notification, index) => {
						return (
							<Box
								key={index}
								sx={{
									padding: '5px 5px',

									'&:hover': {
										backgroundColor: theme.palette.background.default,
										cursor: notification.to ? 'pointer' : '',
									},
								}}
								onClick={() => {
									handleClose();
									notification.onclick?.();
									notification.to ? navigate(notification.to) : null;
								}}
							>
								<Stack
									direction="row"
									spacing={1}
									alignItems="center"
									justifyContent="flex-start"
									sx={{ minHeight: '30px' }}
								>
									<Box>
										{notificationType === 'document' ? (
											<AppCustomIcon
												tag={`document_format_${notification.icon}`}
												color="secondary"
											/>
										) : notificationType === 'news' ? (
											''
										) : (
											''
										)}
									</Box>
									<Box sx={{ width: '80%' }}>
										<Typography sx={{ fontSize: '0.8rem' }} noWrap>
											{notification.message}
										</Typography>
									</Box>
								</Stack>
							</Box>
						);
					})}
			</Box>
		</Box>
	);
};

export default AppNotification;
